export const blockIconsMapsEastNew = (
	<span className='material-symbols-outlined'>east</span>
);
